import { LocationFormData } from './validationSchema';
import { MapContent } from './MapContent';
import React from 'react';
import { useFormikContext } from 'formik';
import { APIProvider } from '@vis.gl/react-google-maps';
import { getGoogleMapsApiKey } from '@/common/application/utils/getGoogleMapsApiKey';
import { useLocationFormMap } from './hooks/useLocationFormMap';
import { CountryPrefillFromGeocode } from './CountryPrefillFromGeocode';
import { ZipPrefillFromGeocode } from './ZipPrefillFromGeocode';

interface LocationFormProps {
  // Optional props for customization
  className?: string;
  hideCoordinates?: boolean;
  hideCountry?: boolean;
}

const LocationForm: React.FC<LocationFormProps> = ({ className, hideCoordinates = false, hideCountry = false }) => {
  const formik = useFormikContext<LocationFormData>();

  const {
    selectedPlace,
    markerPosition,
    selectedPlaceDetails,
    setSelectedPlaceDetails,
    handlePlaceSelect,
    handleMarkerDragEnd,
    setMarkerPosition,
    highlightedFields,
    updateFormValues
  } = useLocationFormMap(formik);

  return (
    <div className={className}>
      <APIProvider apiKey={getGoogleMapsApiKey() ?? ''}>
        <CountryPrefillFromGeocode setSelectedPlaceDetails={setSelectedPlaceDetails} />
        <ZipPrefillFromGeocode setSelectedPlaceDetails={setSelectedPlaceDetails} />
        <MapContent
          onPlaceSelect={handlePlaceSelect}
          setMarkerPosition={setMarkerPosition}
          selectedPlaceDetails={selectedPlaceDetails}
          setSelectedPlaceDetails={setSelectedPlaceDetails}
          markerPosition={markerPosition}
          selectedPlace={selectedPlace}
          onMarkerDragEnd={handleMarkerDragEnd}
          highlightedFields={highlightedFields}
          updateFormValues={updateFormValues}
          hideCoordinates={hideCoordinates}
          hideCountry={hideCountry}
        />
      </APIProvider>
    </div>
  );
};

export default LocationForm;
